<template functional>
  <div :class="['c-notice', `c-notice--${props.variant} ${data.staticClass || ''}`]">
    <font-awesome-icon v-if="props.icon" class="c-notice__icon" :icon="props.icon" />
    <div class="c-notice__content">
      <slot>{{ props.label }}</slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseNotice',

  props: {
    variant: {
      default: 'default',
      type: String,
      validator: value => [ 'danger', 'default', 'success', 'warning' ].includes(value)
    },
    label: {
      type: String
    },
    icon: {
      type: Array
    }
  }
}
</script>
